/**
 * User: herbert
 * Date: 20.10.15
 * Time: 19:18
 */

import Reflux from 'reflux';

export default Reflux.createActions({
	/** switch to next step */
	next: {},
	/** switch to previous step */
	prev: {},
	/** switch to named step
	 * @param name name of target step
	 * @param [subname] name of substep of target step
	 * */
	switchStep: {},
	/**
	 * keep step but change substep
	 * @param subname name of substep of target step
	 */
	switchSubStep: {},
	/** set additional css class useable for scenes representing various stele scopes
	 * use the key to identify the css class(es) you set, the value to set or remove it(them)
	 * @param{Object} extraDefinition Key-Value-Object containing definition of the extra class or null as value to remove extra class
	 */
	setExtraClass: {}
});
